function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_726",
  "data-name": "Ret\\xE2ngulo 726",
  width: 40.967,
  height: 45.147,
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1369",
  "data-name": "Grupo 1369",
  transform: "translate(-17.713)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1365",
  "data-name": "Grupo 1365",
  transform: "translate(17.713 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1364",
  "data-name": "Grupo 1364",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1363",
  "data-name": "Grupo 1363",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_595",
  "data-name": "Caminho 595",
  d: "M372.936,359.757H336.359a2.017,2.017,0,0,1-2.015-2.014v-37.35a2.017,2.017,0,0,1,2.015-2.014h36.577a2.017,2.017,0,0,1,2.015,2.014v37.35a2.017,2.017,0,0,1-2.015,2.014Zm-36.577-40.106a.743.743,0,0,0-.743.742v37.35a.743.743,0,0,0,.743.742h36.577a.743.743,0,0,0,.742-.742v-37.35a.743.743,0,0,0-.742-.742Zm0,0",
  transform: "translate(-334.302 -318.102)",
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_596",
  "data-name": "Caminho 596",
  d: "M374.3,394.893H334.967a.636.636,0,0,1,0-1.272H374.3a.636.636,0,0,1,0,1.272Zm0,0",
  transform: "translate(-334.291 -384.122)",
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
}))), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_597",
  "data-name": "Caminho 597",
  d: "M594.4,345.8a2.521,2.521,0,1,1,2.521-2.521A2.521,2.521,0,0,1,594.4,345.8Zm0-3.771a1.249,1.249,0,1,0,1.25,1.249,1.249,1.249,0,0,0-1.25-1.249Zm0,0",
  transform: "translate(-560.277 -337.734)",
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_598",
  "data-name": "Caminho 598",
  d: "M369.495,345.8a2.521,2.521,0,1,1,2.521-2.521,2.522,2.522,0,0,1-2.521,2.521Zm0-3.771a1.249,1.249,0,1,0,1.249,1.249,1.249,1.249,0,0,0-1.249-1.249Zm0,0",
  transform: "translate(-362.932 -337.734)",
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_599",
  "data-name": "Caminho 599",
  d: "M445.833,346.848H429.722a.636.636,0,0,1-.636-.636v-3.428a.636.636,0,0,1,.636-.636h16.111a.636.636,0,0,1,.636.636v3.428a.636.636,0,0,1-.636.636Zm-15.475-1.272H445.2V343.42H430.358Zm0,0",
  transform: "translate(-417.432 -338.957)",
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_600",
  "data-name": "Caminho 600",
  d: "M424.854,459.583a10.494,10.494,0,1,1,9.731-14.416.636.636,0,0,1-1.179.476,9.226,9.226,0,1,0-.18,7.3.636.636,0,0,1,1.156.53,10.5,10.5,0,0,1-9.527,6.112Zm0,0",
  transform: "translate(-404.509 -423.583)",
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_601",
  "data-name": "Caminho 601",
  d: "M443.911,476.229a7.794,7.794,0,1,1,6.764-11.655.636.636,0,0,1-1.1.636,6.525,6.525,0,1,0-.173,6.737.636.636,0,0,1,1.072.685,7.753,7.753,0,0,1-6.561,3.6Zm0,0",
  transform: "translate(-423.595 -442.927)",
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_602",
  "data-name": "Caminho 602",
  d: "M549.068,498.055h-3.085a.98.98,0,0,1-.979-.979v-7.113a.98.98,0,0,1,.979-.979h3.085a.98.98,0,0,1,.978.979v7.113a.98.98,0,0,1-.978.979Zm-2.792-1.272h2.5v-6.526h-2.5Zm0,0",
  transform: "translate(-519.143 -467.797)",
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_603",
  "data-name": "Caminho 603",
  d: "M569.117,650.023H562.8a.636.636,0,0,1-.636-.636v-3.142a.636.636,0,0,1,.636-.636h6.313a.636.636,0,0,1,.636.636v3.142a.636.636,0,0,1-.636.636Zm-5.677-1.272h5.041v-1.87H563.44Zm0,0",
  transform: "translate(-534.203 -605.226)",
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_604",
  "data-name": "Caminho 604",
  d: "M382.308,650.023H376a.636.636,0,0,1-.636-.636v-3.142a.636.636,0,0,1,.636-.636h6.313a.636.636,0,0,1,.636.636v3.142a.636.636,0,0,1-.636.636Zm-5.677-1.272h5.041v-1.87h-5.041Zm0,0",
  transform: "translate(-370.29 -605.226)",
  fill: "#0078d7",
  stroke: "#fff",
  strokeWidth: 0.1
})));

function SvgAppliance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.967,
    height: 45.147,
    viewBox: "0 0 40.967 45.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliance);
export default __webpack_public_path__ + "static/media/appliance.36bdb2a0.svg";
export { ForwardRef as ReactComponent };